import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";

function App() {
  return (
    <div className="App">
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#130A1F",
            border: "1px solid rgba(212,175,55,0.4)",
            color: "#F9F6F0",
            borderRadius: 0,
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
